// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"2adcf355","213":"53c4141a","383":"2881585c","446":"acb5f32f","842":"ef0c8e26"}[chunkId] + ".chunk.css";
};